import {useMemo} from "react";
import {DispatchEntity} from "@ots-frontend/ots-data";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";

export type UseDispatchDataTableFilterProps = Omit<UseDataTableFilterProps<DispatchEntity>, 'filterConfig'>

export function useDispatchDataTableFilter(props: UseDispatchDataTableFilterProps): UseDataTableFilterResult<DispatchEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const filterConfig: DataTableFilterConfig<DispatchEntity> = useMemo(() => {
    return {}
  }, [
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
